import { Formik, Form, Field } from 'formik';
import useCreateShare from './hooks/useCreateShare';

interface CreateShareFormProps {
    galleryInfo: GalleryObject | null;
    onShare: (destination: string) => void;
    setIsSharing: (isSharing: boolean) => void;
    defaultDestination: string;
    type: ShareType;
    onReset: () => void;
    shareIdentifiers: string[];
}

function isValidEmail(email: string) {
    // eslint-disable-next-line no-useless-escape
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

function isValidPhoneNumber(phoneNumber: string) {
    var regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return regex.test(phoneNumber);
}

export default function CreateShareForm({
    galleryInfo,
    onShare,
    setIsSharing,
    defaultDestination,
    type,
    onReset,
    shareIdentifiers,
}: CreateShareFormProps) {
    const { defaultShareValues, shareCallback } = useCreateShare(
        onShare,
        setIsSharing,
        defaultDestination,
        galleryInfo,
        type,
        undefined,
        shareIdentifiers,
    );

    const validate = (values: CreateShareFormValues) => {
        const errors: any = {};
        const { destination, type } = values;
        if (!destination) {
            errors.destination = 'required';
        } else if (type === 0) {
            if (!isValidEmail(destination)) {
                errors.destination = 'email address is invalid';
            }
        } else if (type === 1) {
            if (!isValidPhoneNumber(destination)) {
                errors.destination = 'phone number is invalid';
            }
        }

        return errors;
    };

    return (
        <div className="Share-body">
            <br />
            <Formik
                validate={validate}
                initialValues={defaultShareValues}
                onSubmit={async (values, actions) => {
                    await shareCallback(values);
                    actions.setSubmitting(false);
                }}
            >
                {({ values, errors, touched }) => (
                    <Form className="Share-form">
                        {errors.destination && touched.destination && (
                            <div className="Form-error">
                                {errors.destination}
                            </div>
                        )}
                        <Field
                            id="destination"
                            name="destination"
                            placeholder={
                                values.type === 0
                                    ? 'hello@smilebooth.com'
                                    : '(281) 330-8004'
                            }
                            className="destination-field"
                            type={values.type === 0 ? 'email' : 'tel'}
                        />
                        <br />
                        <button type="submit" className="cta-button">
                            add to my gallery
                        </button>
                        <span
                            onClick={onReset}
                            className="cta-button no-border"
                        >
                            <i className="bi bi-arrow-left"></i>
                        </span>
                    </Form>
                )}
            </Formik>
        </div>
    );
}
